import { Link } from 'react-router-dom';
import type { Article } from '@/mocks/articles';

interface ArticleCardProps {
  article: Article;
}

export default function ArticleCard({ article }: ArticleCardProps) {
  return (
    <article className="group bg-background-50 rounded-lg overflow-hidden border border-background-200/70 hover:border-accent-200/60 transition-all duration-300 flex flex-col">
      <Link to={`/article/${article.slug}`} className="block overflow-hidden cursor-pointer">
        <div className="relative w-full aspect-[16/9] overflow-hidden">
          <img
            src={article.image}
            alt={article.title}
            title={`${article.title} - 菲律宾电影资讯`}
            className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
          />
          {article.featured && (
            <span className="absolute top-3 left-3 px-2.5 py-1 bg-primary-500 text-background-50 text-xs font-medium rounded-md whitespace-nowrap">
              精选
            </span>
          )}
          <span className="absolute top-3 right-3 px-2.5 py-1 bg-background-50/90 backdrop-blur-sm text-foreground-700 text-xs font-medium rounded-md whitespace-nowrap">
            {article.category}
          </span>
        </div>
      </Link>
      <div className="p-4 md:p-5 flex flex-col flex-1">
        <Link to={`/article/${article.slug}`} className="cursor-pointer">
          <h3 className="font-heading text-base md:text-lg font-semibold text-foreground-900 group-hover:text-primary-600 transition-colors line-clamp-2 mb-2">
            {article.title}
          </h3>
        </Link>
        <p className="text-sm text-foreground-500 leading-relaxed line-clamp-2 mb-4 flex-1">
          {article.excerpt}
        </p>
        <div className="flex items-center justify-between text-xs text-foreground-400">
          <div className="flex items-center gap-3">
            <span className="flex items-center gap-1">
              <i className="ri-calendar-line"></i>
              {article.date}
            </span>
            <span className="flex items-center gap-1">
              <i className="ri-time-line"></i>
              {article.readTime}
            </span>
          </div>
          <Link
            to={`/article/${article.slug}`}
            className="flex items-center gap-1 text-primary-500 hover:text-primary-600 font-medium transition-colors whitespace-nowrap cursor-pointer"
          >
            阅读
            <i className="ri-arrow-right-line"></i>
          </Link>
        </div>
      </div>
    </article>
  );
}